import { useEffect, useRef } from 'react';
import { useRouteLoaderData } from 'react-router';
import { id as appLayoutId } from '@/layout/app-layout';

export function usePing(onPing: () => void, clubId?: string) {
  // Try to get club ID from app-layout loader if clubId not provided
  // This allows backward compatibility while supporting cashier layout
  const appLayoutData = useRouteLoaderData(appLayoutId) as { club: { id: string } } | undefined;
  const clubFromHook = appLayoutData?.club;

  const clubIdToUse = clubId ?? clubFromHook?.id;

  const esRef = useRef<EventSource | null>(null);

  useEffect(() => {
    if (!clubIdToUse) {
      // Don't set up SSE if we don't have a club ID
      return;
    }

    const url = `${import.meta.env.VITE_REALTIME_ORIGIN}/club/${encodeURIComponent(
      clubIdToUse
    )}/sse`;
    const es = new EventSource(url, { withCredentials: false });
    esRef.current = es;

    const handler = () => onPing();
    es.addEventListener('ping', handler);
    es.addEventListener('keepalive', () => {});

    return () => {
      es.close();
      esRef.current = null;
    };
  }, [clubIdToUse, onPing]);
}
